const PLURAL_ACRONYM_PATTERN = /^[A-Z]{2,}s$/;
const WORD_SEPARATOR = ' ';

export function toCapsLabel(label: string): string {
  return label
    .split(WORD_SEPARATOR)
    .map((word) => (PLURAL_ACRONYM_PATTERN.test(word) ? word : word.toUpperCase()))
    .join(WORD_SEPARATOR);
}
